import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timer"]
  static values = {
    duration: { type: Number, default: 120 } // 2 minutes in seconds
  }

  connect() {
    this.remainingSeconds = this.durationValue
    this.startCountdown()
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  startCountdown() {
    this.updateDisplay()
    
    this.interval = setInterval(() => {
      this.remainingSeconds--
      
      if (this.remainingSeconds <= 0) {
        clearInterval(this.interval)
        this.timerTarget.textContent = "0:00"
        this.handleExpiration()
      } else {
        this.updateDisplay()
      }
    }, 1000)
  }

  updateDisplay() {
    const minutes = Math.floor(this.remainingSeconds / 60)
    const seconds = this.remainingSeconds % 60
    this.timerTarget.textContent = `${minutes}:${seconds.toString().padStart(2, "0")}`
    
    // Change color when less than 30 seconds
    if (this.remainingSeconds <= 30) {
      this.timerTarget.classList.add("text-red-600", "dark:text-red-400")
    }
  }

  handleExpiration() {
    // Show expiration message
    const form = this.element.closest("form")
    if (form) {
      const submitBtn = form.querySelector("[type='submit']")
      if (submitBtn) {
        submitBtn.disabled = true
        submitBtn.textContent = "Code expired"
      }
    }
  }
}

